import {
  Product,
  ProductApi,
  ProductFormData,
  ProductFormDataApi,
  ProductFormErrors,
  ProductFormErrorsApi,
  ProductSelect,
  ProductSelectApi,
  ProductType,
} from '../types'

export class ProductMappers {
  public static fromApi(product: ProductApi): Product {
    return {
      id: product.id,
      name: product.product_name,
      barcode: product.barcode,
      itemCode: product.item_code,
      price: product.price ?? 0,
      country: {
        id: product.manufacturer_country?.id ?? 0,
        code: product.manufacturer_country?.country_code ?? '',
        name: product.manufacturer_country?.country_name ?? '',
      },
      hasExpireDate: !!product.has_expiry_date,
      criticalThreshold: product.critical_threshold ?? 0,
      type: product.type as ProductType,
      status: {
        id: product.state.id ?? 0,
        name: product.state?.state_name ?? '',
      },
      category: {
        id: product.category?.id ?? 0,
        name: product.category?.product_category_name ?? '',
      },
      measurementUnit: {
        id: product.measurement_unit?.id ?? 0,
        name: product.measurement_unit?.unit_name ?? '',
        symbol: product.measurement_unit?.unit_symbol ?? '',
      },
      descr: product.descr ?? '',
      updatedAt: product.updated_at,
      createdAt: product.created_at,
    }
  }

  public static manyFromApi(raw: ProductApi[]): Product[] {
    return raw.map((item) => ProductMappers.fromApi(item))
  }

  public static selectFromApi(product: ProductSelectApi): ProductSelect {
    return {
      id: product.id,
      name: product.product_name,
      barcode: product.barcode,
      itemCode: product.item_code,
      measurementUnitName: product.measurement_unit_name,
      categoryName: product.category_name,
      descr: product.descr,
      hasExpiryDate: product.has_expiry_date,
    }
  }

  public static manySelectFromApi(raw: ProductSelectApi[]): ProductSelect[] {
    return raw.map((item) => ProductMappers.selectFromApi(item))
  }

  public static formDataToApi(formData: ProductFormData): ProductFormDataApi {
    return {
      product_id: formData.id,
      product_name: formData.productName,
      item_code: formData.itemCode,
      type: formData.type,
      manufacturer_country_id: formData.manufacturerCountryId,
      barcode: formData.barcode,
      measurement_unit_id: formData.measurementUnitId,
      critical_threshold: formData.criticalThreshold,
      has_expiry_date: !!formData.hasExpiryDate ? 1 : 0,
      product_category_id: formData.categoryId,
      state_id: formData.statusId,
      descr: formData.descr,
    }
  }

  public static formErrorsFromApi(errors: ProductFormErrorsApi): ProductFormErrors {
    return {
      id: errors.product_id,
      barcode: errors.barcode,
      categoryId: errors.product_category_id,
      criticalThreshold: errors.critical_threshold,
      descr: errors.descr,
      itemCode: errors.item_code,
      hasExpiryDate: errors.has_expiry_date,
      manufacturerCountryId: errors.manufacturer_country_id,
      measurementUnitId: errors.measurement_unit_id,
      productName: errors.product_name,
      statusId: errors.state_id,
      type: errors.type,
      _custom: errors._custom,
    }
  }

  public static formInitializer(product: Product): ProductFormData {
    return {
      id: product.id.toString(),
      productName: product.name,
      barcode: product.barcode,
      criticalThreshold: product.criticalThreshold,
      itemCode: product.itemCode,
      descr: product.descr,
      hasExpiryDate: product.hasExpireDate,
      type: product.type as ProductType,
      manufacturerCountryId: product.country?.id?.toString() ?? '',
      measurementUnitId: product.measurementUnit?.id?.toString() ?? '',
      categoryId: product.category?.id?.toString() ?? '',
      statusId: product.status?.id?.toString() ?? '',
    }
  }
}
